import { Type } from '@angular/core';
import { ClickElement } from './base-element';
import { ElementType } from './element-type';

export class Text extends ClickElement {
  value: string;

  constructor(value: string) {
    super();
    this.elementType = ElementType.text;
    this.value = value;
  }
}
